import { render, staticRenderFns } from "./form-auth.vue?vue&type=template&id=2db15e4b&scoped=true"
import script from "./form-auth.vue?vue&type=script&lang=js"
export * from "./form-auth.vue?vue&type=script&lang=js"
import style0 from "./form-auth.vue?vue&type=style&index=0&id=2db15e4b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db15e4b",
  null
  
)

export default component.exports